// Mock data for SSAMVISION Broadband

export const featuredPlans = [
  {
    id: '100mbps',
    speed: '100 MBPS',
    type: 'WiFi',
    tagline: 'Best Buy Pack',
    plans: [
      { price: 650, validity: '1 Month', monthly: 650 },
      { price: 1700, validity: '3 Month', monthly: 567 },
      { price: 3250, validity: '6 Month', monthly: 542 },
      { price: 6250, validity: '12 Month', monthly: 521 }
    ],
    features: ['Unlimited Internet', 'High Speed Connection', 'Easy to approach service']
  },
  {
    id: '200mbps',
    speed: '200 MBPS',
    type: 'WiFi',
    tagline: 'Best Price Challenge',
    plans: [
      { price: 750, validity: '1 Month', monthly: 750 },
      { price: 2200, validity: '3 Month', monthly: 733 },
      { price: 4000, validity: '6 Month', monthly: 667 },
      { price: 7500, validity: '12 Month', monthly: 625 }
    ],
    features: ['Unlimited Internet', 'High Speed Connection', 'Easy to approach service']
  },
  {
    id: '300mbps',
    speed: '300 MBPS',
    type: 'WiFi',
    tagline: 'Top Speed',
    plans: [
      { price: 850, validity: '1 Month', monthly: 850 },
      { price: 2400, validity: '3 Month', monthly: 800 },
      { price: 4250, validity: '6 Month', monthly: 708 },
      { price: 8500, validity: '12 Month', monthly: 708 }
    ],
    features: ['Unlimited Internet', 'Ultra-Fast 300 Mbps', 'Perfect for streaming & gaming']
  }
];

export const allWifiPlans = [
  { speed: '20 Mbps', monthly: 300, threeMonth: 850, sixMonth: 1500, tenPlusTwo: 3000 },
  { speed: '30 Mbps', monthly: 350, threeMonth: 1000, sixMonth: 1750, tenPlusTwo: 3500 },
  { speed: '40 Mbps', monthly: 450, threeMonth: 1250, sixMonth: 2250, tenPlusTwo: 4500 },
  { speed: '50 Mbps', monthly: 550, threeMonth: 1500, sixMonth: 2750, tenPlusTwo: 5500 },
  { speed: '75 Mbps', monthly: 600, threeMonth: 1650, sixMonth: 2950, tenPlusTwo: 5650, highlighted: true },
  { speed: '100 Mbps', monthly: 650, threeMonth: 1700, sixMonth: 3250, tenPlusTwo: 6250, highlighted: true },
  { speed: '150 Mbps', monthly: 700, threeMonth: 1900, sixMonth: 3500, tenPlusTwo: 7000 },
  { speed: '200 Mbps', monthly: 750, threeMonth: 2200, sixMonth: 4000, tenPlusTwo: 7500 },
  { speed: '300 Mbps', monthly: 850, threeMonth: 2400, sixMonth: 4250, tenPlusTwo: 8500 }
];

export const wifiTvPlans = [
  { speed: '20 Mbps + TV', monthly: 550, threeMonth: 1550, sixMonth: 3000, tenPlusTwo: 5500 },
  { speed: '30 Mbps + TV', monthly: 600, threeMonth: 1700, sixMonth: 3200, tenPlusTwo: 6200 },
  { speed: '40 Mbps + TV', monthly: 700, threeMonth: 1800, sixMonth: 3400, tenPlusTwo: 6400 },
  { speed: '50 Mbps + TV', monthly: 800, threeMonth: 2000, sixMonth: 4000, tenPlusTwo: 7500, highlighted: true },
  { speed: '75 Mbps + TV', monthly: 850, threeMonth: 2300, sixMonth: 4500, tenPlusTwo: 8500, highlighted: true },
  { speed: '100 Mbps + TV', monthly: 900, threeMonth: 2500, sixMonth: 4750, tenPlusTwo: 9000, highlighted: true },
  { speed: '150 Mbps + TV', monthly: 950, threeMonth: 2600, sixMonth: 5000, tenPlusTwo: 9500 },
  { speed: '200 Mbps + TV', monthly: 1000, threeMonth: 2800, sixMonth: 5250, tenPlusTwo: 10000 }
];

export const ottPlatforms = [
  'Disney+ Hotstar', 'Sony LIV', 'ZEE5', 'ALT Balaji', 
  'Epic ON', 'Fancode', 'Hungama Music', 'Hungama Play',
  'iTap', 'Discovery+', 'SunNxt', 'Shemaroo'
];

export const ottPlatformsWithLogos = [
  { name: 'ZEE5', logo: 'https://customer-assets.emergentagent.com/job_webfiber/artifacts/aeio46z8_zee5-logo-png_seeklogo-482941.png' },
  { name: 'Fancode', logo: 'https://customer-assets.emergentagent.com/job_webfiber/artifacts/azapdmep_Fancode.png' },
  { name: 'ETV Win', logo: 'https://customer-assets.emergentagent.com/job_webfiber/artifacts/2m8z3qac_etv.png' },
  { name: 'Aha', logo: 'https://customer-assets.emergentagent.com/job_webfiber/artifacts/m5d7w325_aha-tv-logo.webp' },
  { name: 'Shemaroo TV', logo: 'https://customer-assets.emergentagent.com/job_webfiber/artifacts/oprnjtmg_Shemaroo_TV.webp' },
  { name: 'Hungama TV', logo: 'https://customer-assets.emergentagent.com/job_webfiber/artifacts/kc2zoy9z_Hungama_TV.svg.png' },
  { name: 'SUN NXT', logo: 'https://customer-assets.emergentagent.com/job_webfiber/artifacts/63blbm9r_SunNXT.png' },
  { name: 'Jio Hotstar', logo: 'https://customer-assets.emergentagent.com/job_webfiber/artifacts/qr7iac4d_jiohotstar-logo-hd.webp' },
  { name: 'Smart Play TV', logo: 'https://customer-assets.emergentagent.com/job_webfiber/artifacts/i6xly8jl_smartplaytv.png' }
];

export const companyInfo = {
  name: 'SSM VISION',
  tagline: 'Connect Global Surf Local BroadBand',
  phone: '7995715553',
  email: 'ssmvisionbroadband@gmail.com',
  address: 'SSM Vision Mettuguda, 12-8-253/A, Hyderabad'
};

export const whyChooseUs = [
  {
    title: 'High-Speed Internet',
    description: 'Experience blazing fast speeds up to 300 Mbps for seamless streaming and browsing',
    icon: 'Zap'
  },
  {
    title: 'Affordable Plans',
    description: 'Best price guarantee with plans starting as low as ₹299 per month',
    icon: 'IndianRupee'
  },
  {
    title: 'Easy to Approach Service',
    description: 'Friendly customer support ready to assist you with any queries',
    icon: 'Headphones'
  },
  {
    title: 'Cable TV + OTT',
    description: '350+ live channels and 14+ OTT platforms in combo packages',
    icon: 'Tv'
  },
  {
    title: 'Unlimited Data',
    description: 'No data caps, no FUP limits - truly unlimited internet',
    icon: 'Infinity'
  },
  {
    title: 'Quick Installation',
    description: 'Fast and hassle-free installation within 24-48 hours',
    icon: 'Wifi'
  }
];
